<script setup lang="ts">
import DsIcon from './DsIcon.vue'

withDefaults(defineProps<{ mode: 'loading' | 'empty' | 'error'; title?: string; description?: string }>(), {
  title: '',
  description: '',
})
defineEmits<{ retry: [] }>()
</script>

<template>
  <div class="state-panel" role="status">
    <DsIcon v-if="mode === 'loading'" class="spin" name="refresh" :size="34" />
    <DsIcon v-else-if="mode === 'error'" name="warning" :size="34" />
    <DsIcon v-else name="inventory_2" :size="34" />
    <strong>{{ title || (mode === 'loading' ? '正在加载' : mode === 'error' ? '暂时没有加载成功' : '这里还没有内容') }}</strong>
    <p v-if="description">{{ description }}</p>
    <button v-if="mode === 'error'" class="button button-secondary" type="button" @click="$emit('retry')">重新加载</button>
  </div>
</template>
